{
  "background": {
    "default": {
      "$type": "color",
      "$description": "Page canvas — the base background behind all content.",
      "$value": "#fafafa"
    },
    "subtle": {
      "$type": "color",
      "$description": "Subtly differentiated background for alternating or grouped sections.",
      "$value": "#f5f5f5"
    }
  },
  "surface": {
    "default": {
      "$type": "color",
      "$description": "Default container surface — cards, panels, and inputs on the page.",
      "$value": "#ffffff"
    },
    "raised": {
      "$type": "color",
      "$description": "Raised surface for higher-elevation layers (menus, popovers, dialogs). Higher elevation reads lighter in dark mode.",
      "$value": "#ffffff"
    },
    "sunken": {
      "$type": "color",
      "$description": "Recessed surface for wells and inset regions.",
      "$value": "#f5f5f5"
    }
  },
  "text": {
    "default": {
      "$type": "color",
      "$description": "Primary body and heading text.",
      "$value": "#0e1113"
    },
    "muted": {
      "$type": "color",
      "$description": "Secondary text — supporting copy, captions, metadata.",
      "$value": "#495054"
    },
    "subtle": {
      "$type": "color",
      "$description": "Tertiary text — placeholders and disabled labels. The mid-grey reads in both modes.",
      "$value": "#888f92"
    },
    "inverse": {
      "$type": "color",
      "$description": "Text and icons rendered on an action or solid fill.",
      "$value": "#ffffff"
    },
    "link": {
      "$type": "color",
      "$description": "Inline hyperlink text.",
      "$value": "#002664"
    }
  },
  "border": {
    "default": {
      "$type": "color",
      "$description": "Default border for inputs, cards, and dividers.",
      "$value": "#dcdfe0"
    },
    "subtle": {
      "$type": "color",
      "$description": "Low-emphasis border for subtle separation.",
      "$value": "#ebebeb"
    },
    "strong": {
      "$type": "color",
      "$description": "High-emphasis border for focus and selected states.",
      "$value": "#888f92"
    }
  },
  "action": {
    "default": {
      "$type": "color",
      "$description": "Primary interactive colour — buttons, links, key accents. NSW navy in light, brightened for contrast in dark.",
      "$value": "#002664"
    },
    "hover": {
      "$type": "color",
      "$description": "Hover and active state for primary actions.",
      "$value": "#001037"
    },
    "subtle": {
      "$type": "color",
      "$description": "Tinted background for low-emphasis (ghost) actions.",
      "$value": "#f0fbff"
    }
  },
  "success": {
    "surface": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — tinted background.",
      "$value": "#eff9ed"
    },
    "text": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — readable text on the tint.",
      "$value": "#005a02"
    },
    "border": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — border and divider.",
      "$value": "#8fc78a"
    },
    "solid": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — solid fill for badges and icons.",
      "$value": "#008a07"
    }
  },
  "warning": {
    "surface": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — tinted background.",
      "$value": "#fff3ed"
    },
    "text": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — readable text on the tint.",
      "$value": "#882f03"
    },
    "border": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — border and divider.",
      "$value": "#eea88a"
    },
    "solid": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — solid fill for badges and icons.",
      "$value": "#c95000"
    }
  },
  "danger": {
    "surface": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — tinted background.",
      "$value": "#fff0ef"
    },
    "text": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — readable text on the tint.",
      "$value": "#7c061f"
    },
    "border": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — border and divider.",
      "$value": "#ea9294"
    },
    "solid": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — solid fill for badges and icons.",
      "$value": "#b81237"
    }
  },
  "info": {
    "surface": {
      "$type": "color",
      "$description": "Info (neutral information) — tinted background.",
      "$value": "#e9eef7"
    },
    "text": {
      "$type": "color",
      "$description": "Info (neutral information) — readable text on the tint.",
      "$value": "#193366"
    },
    "border": {
      "$type": "color",
      "$description": "Info (neutral information) — border and divider.",
      "$value": "#8098c2"
    },
    "solid": {
      "$type": "color",
      "$description": "Info (neutral information) — solid fill for badges and icons.",
      "$value": "#2e5299"
    }
  }
}
